import { render, staticRenderFns } from "./BulkAssignUserModal.vue?vue&type=template&id=9b4285ba"
import script from "./BulkAssignUserModal.vue?vue&type=script&lang=js"
export * from "./BulkAssignUserModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAssignUserModal.vue?vue&type=style&index=0&id=9b4285ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports